// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Survey from "./survey.js"
import SurveyStepElement from "./survey-step-element.js"

const modelClassData = {
  "attributes": {
    "copyable": {
      "column": {
        "default": "0",
        "name": "copyable",
        "null": false,
        "type": "boolean"
      },
      "name": "copyable",
      "selected_by_default": null,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "liquid_conditions": {
      "column": {
        "default": null,
        "name": "liquid_conditions",
        "null": true,
        "type": "text"
      },
      "name": "liquid_conditions",
      "selected_by_default": null,
      "translated": false
    },
    "position": {
      "column": {
        "default": "0",
        "name": "position",
        "null": false,
        "type": "integer"
      },
      "name": "position",
      "selected_by_default": null,
      "translated": false
    },
    "survey_id": {
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": null
      },
      "name": "survey_id",
      "selected_by_default": null,
      "translated": false
    },
    "survey_step_elements_count": {
      "column": {
        "default": "0",
        "name": "survey_step_elements_count",
        "null": false,
        "type": "integer"
      },
      "name": "survey_step_elements_count",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "SurveyStep",
  "collectionKey": "survey_steps",
  "collectionName": "survey_steps",
  "i18nKey": "survey_step",
  "camelizedLower": "surveyStep",
  "name": "SurveyStep",
  "nameDasherized": "survey-step",
  "pluralName": "survey_steps",
  "ransackable_associations": [
    {
      "className": "SurveyStep::Audit",
      "collectionName": "survey_step_audits",
      "foreignKey": "survey_step_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "SurveyStepAudit",
      "through": null
    },
    {
      "className": "SurveyStep::Audit",
      "collectionName": "survey_step_audits",
      "foreignKey": "survey_step_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "SurveyStepAudit",
      "through": null
    },
    {
      "className": "SurveyStep::Translation",
      "collectionName": null,
      "foreignKey": "survey_step_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "survey_step_id",
      "name": "elements",
      "macro": "has_many",
      "resource_name": "SurveyStepElement",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "TeamSurveyStep",
      "collectionName": "team_survey_steps",
      "foreignKey": "survey_step_id",
      "name": "team_survey_steps",
      "macro": "has_many",
      "resource_name": "TeamSurveyStep",
      "through": null
    },
    {
      "className": "SurveyStep::Translation",
      "collectionName": null,
      "foreignKey": "survey_step_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "copyable",
      "column": {
        "default": "0",
        "name": "copyable",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "liquid_conditions",
      "column": {
        "default": null,
        "name": "liquid_conditions",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "position",
      "column": {
        "default": "0",
        "name": "position",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "survey_id",
      "column": {
        "default": null,
        "name": "survey_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "survey_step_elements_count",
      "column": {
        "default": "0",
        "name": "survey_step_elements_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "survey_step_id",
      "name": "elements",
      "macro": "has_many",
      "resource_name": "SurveyStepElement",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    }
  ],
  "paramKey": "survey_step",
  "primaryKey": "id"
}

/** Frontend model for SurveyStep. */
export default class SurveyStep extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {boolean} */
  copyable() {
    return this.readAttributeUnderscore("copyable")
  }

  /** @returns {boolean} */
  hasCopyable() {
    const value = this.copyable()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  liquidConditions() {
    return this.readAttributeUnderscore("liquid_conditions")
  }

  /** @returns {boolean} */
  hasLiquidConditions() {
    const value = this.liquidConditions()

    return this._isPresent(value)
  }

  /** @returns {number} */
  position() {
    return this.readAttributeUnderscore("position")
  }

  /** @returns {boolean} */
  hasPosition() {
    const value = this.position()

    return this._isPresent(value)
  }

  /** @returns {any} */
  surveyId() {
    return this.readAttributeUnderscore("survey_id")
  }

  /** @returns {boolean} */
  hasSurveyId() {
    const value = this.surveyId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  surveyStepElementsCount() {
    return this.readAttributeUnderscore("survey_step_elements_count")
  }

  /** @returns {boolean} */
  hasSurveyStepElementsCount() {
    const value = this.surveyStepElementsCount()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  copy(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "copy",
        primaryKey: this.primaryKey(),
        collectionName: "survey_steps",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./survey-step-element.js").default>} */
  elements() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["survey_step_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "elements",
        model: this,
        modelClass: SurveyStepElement
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./survey-step-element.js").default>>} */
  loadElements() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["survey_step_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "elements",
        model: this,
        modelClass: SurveyStepElement
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./survey-step-element.js").default>>} */
  ensureElementsLoaded() {
    return this.ensureAssociationLoaded("elements")
  }

  /** @returns {import("./survey.js").default | null} */
  survey() {
    return this._readBelongsToReflection({modelClass: Survey, reflectionName: "survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadSurvey() {
    if (!("surveyId" in this)) throw new Error("Foreign key method wasn't defined: surveyId")

    const id = this.surveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "survey",
        model: this,
        modelClass: Survey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  ensureSurveyLoaded() {
    return this.ensureAssociationLoaded("survey")
  }
}
